import feed1 from '../assets/images/feed1.jpg'
import feed2 from '../assets/images/feed2.jpg'
import feed3 from '../assets/images/feed3.jpg'
export const feedbackData = [
    {
        id: 1,
        image: feed1,
        name: "Rosalina D. William",
        company: "founder",
        description: "Lorem ipsum dolor sit amet, consectetur adipi sicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
        id: 2,
        image: feed2,
        name: "Rosalina D. William",
        company: "founder",
        description: "Lorem ipsum dolor sit amet, consectetur adipi sicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
        id: 3,
        image: feed3,
        name: "Rosalina D. William",
        company: "founder",
        description: "Lorem ipsum dolor sit amet, consectetur adipi sicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
]
